import { createContext } from "react";

export const LocaleStringContext = createContext<string>(
  undefined as unknown as string
);
